export default "/images/vendor/flag-icon-css/flags/1x1/ci.svg?6f06682eaf98960662af030b21caa3b2";